import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useRouteMatch, useHistory, useLocation } from "react-router-dom";

import { authenticateZoho, updateZoho } from 'actions/integrations/zoho';
import { deactivateIntegration, activatingIntegrationSuccedded } from 'actions/integrations/integrations';

import _ from 'lodash';

import {
  Row,
  Col,
  Button,
  Form,
  Image
} from "react-bootstrap";

import cx from 'classnames';
import styles from './zoho.module.scss';

import { getBaseUrl } from 'services/util';

import buildUrl from 'build-url';
import { toast } from 'react-toastify';
import { SuccessToast } from 'components/Toast';
const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}`;

export const ZohoIntegration = () => {
  const dispatch = useDispatch();
  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const location = useLocation();
  const history = useHistory();

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const deactivating = useSelector(state => _.get(state, 'integrations.activated.deactivating', false));
  const errors = useSelector(state => _.get(state, 'integrations.zoho.changes.error', null));
  const authenticating = useSelector(state => _.get(state, 'integrations.zoho.changes.saving', false));
  const updating = useSelector(state => _.get(state, 'integrations.zoho.changes.updating', false));

  const [authenticated, setAuthenticated] = useState(false);

  const integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type === 'zoho';
  })


  const [state, setState] = useState({
    email: "",
    syncLeadCreatedEvent: true,
    syncPageViewedEvent: true,
    syncAssetViewedEvent: true,
    syncAssetDownloadEvent: true,
    syncICDownloadEvent:true,
    error: ''
  });

  useEffect(state => {
    if (integration && integration.state.code === "ok" && !errors) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
    }

    if (integration != null && integration.configuration != null) {
      
      if(updating) {
        return;
      }

      setState((state) => {
        return {
          ...state,
          email: _.get(integration, 'configuration.email'),
          syncLeadCreatedEvent: _.get(integration, 'configuration.syncLeadCreatedEvent'),
          syncPageViewedEvent: _.get(integration, 'configuration.syncPageViewedEvent'),
          syncAssetViewedEvent: _.get(integration, 'configuration.syncAssetViewedEvent'),
          syncAssetDownloadEvent: _.get(integration, 'configuration.syncAssetDownloadEvent'),
          syncICDownloadEvent: _.get(integration, 'configuration.syncICDownloadEvent'),
        }
      })
    }
    
  }, [integration]);

  const handleDeleteClick = () => {
    dispatch(deactivateIntegration('zoho', (res) => {
      handleBackClick();
    }))
  }

  const handleBackClick = () => {
    var url = `${baseUrl}/integration-settings/integration`;
    history.push(url);
  }

  const handleAuthenticate = () => {
    //Calculate Position
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    const url = buildUrl(apiUrl, {
      path: `/api/1.0/integrations/zoho/authorize`
    })

    var newWindow = window.open(url, `Authorize zoho Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, handleAuthenticateEvent, false);
    return false;
  }

  const handleAuthenticateEvent = (e) => {
    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type === 'ZOHO_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var location = e.data.payload.location;
      var state = e.data.payload.state;
      var error = e.data.payload.error;

      if (!error) {
        dispatch(authenticateZoho(code, location, (response) => {
          dispatch(activatingIntegrationSuccedded(response))
        }))
      }

      deEventer(messageEvent, handleAuthenticateEvent, false);
    }
  }


  const handleRestClick = () => {
    setState((state) => {
      return {
        ...state,
        email: _.get(integration, 'configuration.email', ''),
        syncLeadCreatedEvent: _.get(integration, 'configuration.syncLeadCreatedEvent'),
        syncPageViewedEvent: _.get(integration, 'configuration.syncPageViewedEvent'),
        syncAssetViewedEvent: _.get(integration, 'configuration.syncAssetViewedEvent'),
        syncAssetDownloadEvent: _.get(integration, 'configuration.syncAssetDownloadEvent'),
        syncICDownloadEvent: _.get(integration, 'configuration.syncICDownloadEvent')
      }
    })
  }

  const handleSaveClick = () => {
    var request = {
      email: state.email,
      syncLeadCreatedEvent: state.syncLeadCreatedEvent,
      syncPageViewedEvent: state.syncPageViewedEvent,
      syncAssetViewedEvent: state.syncAssetViewedEvent,
      syncAssetDownloadEvent: state.syncAssetDownloadEvent,
      syncICDownloadEvent: state.syncICDownloadEvent
    }

    dispatch(updateZoho(request, (response) => {
      toast(
        <SuccessToast
          heading={`Success`}
          description={"Zoho Integration Updated Successfully"}
        />,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      dispatch(activatingIntegrationSuccedded(response))
    }))
  }

  const handleSyncEvents = (event) => {
    setState((state) => {
      return {
        ...state,
        [event]: !state[event]
      }
    })
  }

  const integrationData = location.state

  return (
    <div className={styles.zohoContent}>
      <Button variant='light' onClick={handleBackClick} className={styles.backButton} >
        <i className="cleverstory-left" />
        Back
      </Button>
      <div className={styles.formContainer}>
        <Row className={styles.cardWrapper}>
          <Col className={styles.integrationDetail} md={5}>
            <div className={styles.logoContainer}>
              <Image src={integrationData.logo} />
            </div>
            <div className={styles.detailContainer}>
              <span className={styles.title}>{integrationData.title}</span>
              <span className={styles.description}>{integrationData.description}</span>
              {integration && <Button variant='secondary' onClick={handleDeleteClick} className={styles.deactivateButton} >{deactivating ? 'Deactivating...' : 'Deactivate'}</Button>}
              {!integration && <span className={styles.inactiveStatus}>INACTIVE</span>}
            </div>
          </Col>
          <Col className={styles.authForm} md={7}>
            <div className={styles.zohoAuthentication}>
              {!authenticated &&
                <div className={styles.zohoConfig}>
                  <h3 className={styles.configTitle}>Log in to your Zoho account</h3>
                  <span className={styles.configDescription}>Please provide a user account with global access</span>
                  <Button variant='primary' className={styles.authButton} onClick={handleAuthenticate}>
                    {authenticating &&
                      'Authenticating...'
                    }

                    {!authenticating &&
                      'Authenticate'
                    }
                  </Button>
                </div>
              }
              {authenticated && <div className={styles.formWrapper}>
                <Form.Group className="mb-3" controlId="id">
                  <Form.Label className={styles.inputLabel}>EMAIL</Form.Label>
                  <Form.Control className={styles.inputField} value={state.email} name="processBusinessId" type="text" />
                </Form.Group>

                <div className={styles.syncEvents}>
                  <span className={styles.inputLabel}>Sync Event</span>
                  <div className={styles.toggleSwitchContainer}>
                    <span className={cx(styles.content, {[styles.active]: state.syncPageViewedEvent})}>Contact/Lead visits a page</span>
                    <Form.Check
                      type="switch"
                      checked={state.syncPageViewedEvent}
                      onChange={() => handleSyncEvents('syncPageViewedEvent')}
                      className={styles.toggleSwitch}
                      id="lead-visits"
                    />
                  </div>
                  <div className={styles.toggleSwitchContainer}>
                    <span className={cx(styles.content, {[styles.active]: state.syncAssetViewedEvent})}>Contact/Lead views an asset</span>
                    <Form.Check
                      type="switch"
                      checked={state.syncAssetViewedEvent}
                      onChange={() => handleSyncEvents('syncAssetViewedEvent')}
                      className={styles.toggleSwitch}
                      id="lead-views"
                    />
                  </div>
                  <div className={styles.toggleSwitchContainer}>
                    <span className={cx(styles.content, {[styles.active]: state.syncAssetDownloadEvent})}>Contact/Lead download an asset</span>
                    <Form.Check
                      type="switch"
                      checked={state.syncAssetDownloadEvent}
                      onChange={() => handleSyncEvents('syncAssetDownloadEvent')}
                      className={styles.toggleSwitch}
                      id="lead-downloads"
                    />
                  </div>
                  <div className={styles.toggleSwitchContainer}>
                    <span className={cx(styles.content, {[styles.active]: state.syncICDownloadEvent})}>Contact/Lead download an Interactive Content</span>
                    <Form.Check
                      type="switch"
                      checked={state.syncICDownloadEvent}
                      onChange={() => handleSyncEvents('syncICDownloadEvent')}
                      className={styles.toggleSwitch}
                      id="lead-downloads"
                    />
                  </div>
                </div>

              </div>}
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles.actionContainer}>
        <Button variant='secondary' onClick={handleRestClick} className={styles.resetButton}>Reset</Button>
        <Button variant='primary' onClick={handleSaveClick} className={styles.saveButton}>{updating ? 'Saving...' : 'Save Changes'}</Button>
      </div>
    </div>
  )
}
